/*
 * @Author: zhengxiaowen 
 * @Date: 2019-02-25 14:48:19 
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2019-02-25 14:52:57
 */

import Custom from "./Custom"

export default {
    custom: Custom
}


// WEBPACK FOOTER //
// ./src/store/CustomModules.js